// Sélecteur multi-modèles FANUC + size picker pour modèles inconnus.

import { S } from './state.js';
import { $, $$ } from './dom.js';
import {
	FANUC_MODELS, QUICK_PICKS,
	SIZE_IMGS, SIZE_KEYS,
	SIZE_LABELS_FR, SIZE_LABELS_EN,
	SIZE_DETAILS_FR, SIZE_DETAILS_EN,
} from './data.js';
import { computeDuration } from './calendar.js';

function normalize( s ) {
	return ( s || '' ).toLowerCase().replace( /[^a-z0-9]+/g, '' );
}

// Synonymes FR↔EN — étendent un token vers ses équivalents anglais (les catégories du catalogue sont en EN).
var SYNONYMS = {
	soudage:       [ 'welding', 'arc' ],
	soudure:       [ 'welding', 'arc' ],
	peinture:      [ 'painting', 'paint' ],
	palettisation: [ 'palletizing', 'palletisation' ],
	palettiseur:   [ 'palletizing', 'palletisation' ],
	palette:       [ 'palletizing', 'palletisation', 'palettisation' ],
	cobot:         [ 'collaborative', 'crx' ],
	cobotique:     [ 'collaborative', 'crx' ],
	collaboratif:  [ 'collaborative', 'crx' ],
	petit:         [ 'small', 'compact', 'lr' ],
	compact:       [ 'small' ],
	lourd:         [ 'heavy' ],
	grande:        [ 'heavy' ],
	manutention:   [ 'material', 'handling' ],
	scara:         [ 'scara', 'sr' ],
};

function lev( a, b ) {
	var n = a.length, m = b.length;
	if ( ! n ) return m;
	if ( ! m ) return n;
	var prev = new Array( m + 1 );
	for ( var j = 0; j <= m; j++ ) prev[ j ] = j;
	for ( var i = 1; i <= n; i++ ) {
		var curr = [ i ];
		for ( var k = 1; k <= m; k++ ) {
			var cost = a.charCodeAt( i - 1 ) === b.charCodeAt( k - 1 ) ? 0 : 1;
			curr[ k ] = Math.min( curr[ k - 1 ] + 1, prev[ k ] + 1, prev[ k - 1 ] + cost );
		}
		prev = curr;
	}
	return prev[ m ];
}

// Substring match avec tolérance Levenshtein ≤ maxDist sur fenêtres de taille proche.
function approxIn( hay, needle, maxDist ) {
	if ( ! needle ) return false;
	if ( hay.indexOf( needle ) !== -1 ) return true;
	if ( needle.length < 4 ) return false; // pas de fuzzy sur tokens courts (faux positifs)
	var n = needle.length, L = hay.length;
	for ( var i = 0; i <= L - ( n - 1 ); i++ ) {
		for ( var w = -1; w <= 1; w++ ) {
			var size = n + w;
			if ( size <= 0 || i + size > L ) continue;
			if ( lev( hay.substr( i, size ), needle ) <= maxDist ) return true;
		}
	}
	return false;
}

function tokenForms( tok ) {
	var forms = [ tok ];
	var syn = SYNONYMS[ tok ];
	if ( syn ) forms = forms.concat( syn.map( normalize ) );
	return forms;
}

function getGroups( filter ) {
	var raw    = ( filter || '' ).trim();
	var tokens = raw
		? raw.split( /\s+/ ).map( normalize ).filter( Boolean )
		: [];
	var groups = {};
	FANUC_MODELS.forEach( function ( m ) {
		if ( tokens.length ) {
			var nameN = normalize( m.name );
			var catN  = normalize( m.cat );
			var ok = tokens.every( function ( t ) {
				var forms = tokenForms( t );
				return forms.some( function ( f ) {
					return approxIn( nameN, f, 1 ) || approxIn( catN, f, 1 );
				} );
			} );
			if ( ! ok ) return;
		}
		if ( ! groups[ m.cat ] ) groups[ m.cat ] = [];
		groups[ m.cat ].push( m );
	} );
	return groups;
}

export function renderDropdown() {
	var dd = $( 'modelDD' );
	if ( ! dd ) return;
	var q = ( $( 'modelSearch' ) || {} ).value || '';
	var groups = getGroups( q );
	if ( ! Object.keys( groups ).length ) {
		dd.innerHTML = '<div style="padding:14px;text-align:center;font-size:13px;color:var(--steel)">' +
			( S.lang === 'fr' ? 'Aucun résultat.' : 'No results.' ) + '</div>';
		return;
	}
	var html = '';
	Object.keys( groups ).forEach( function ( cat ) {
		html += '<div class="model-group-label">' + cat + '</div>';
		groups[ cat ].forEach( function ( m ) {
			var already = ( S.selModels[ m.id ] || 0 ) > 0;
			html += '<div class="model-opt" data-ps-add="' + m.id + '">' +
				'<div><div class="mn">' + m.name + '</div><div class="mc">' + m.axes + ' axes</div></div>' +
				'<button type="button" class="madd" title="' + ( S.lang === 'fr' ? 'Ajouter' : 'Add' ) + '">' +
				( already ? '+1' : '+' ) + '</button>' +
				'</div>';
		} );
	} );
	dd.innerHTML = html;
}

export function showDropdown() {
	renderDropdown();
	var dd = $( 'modelDD' );
	if ( dd ) dd.classList.add( 'on' );
}

export function hideDropdown() {
	var dd = $( 'modelDD' );
	if ( dd ) dd.classList.remove( 'on' );
	var inp = $( 'modelSearch' );
	if ( inp ) inp.value = '';
}

export function addModel( id ) {
	var m = FANUC_MODELS.find( function ( x ) { return x.id === id; } );
	if ( ! m ) return;
	S.selModels[ id ] = ( S.selModels[ id ] || 0 ) + 1;
	var err = $( 'modelErr' ); if ( err ) err.classList.remove( 'on' );
	renderSelModels();
	var ms = $( 'modelSearch' ); if ( ms ) ms.value = '';
	renderDropdown();
}

export function addQuickPick( id ) {
	if ( ! FANUC_MODELS.find( function ( x ) { return x.id === id; } ) ) {
		FANUC_MODELS.push( QUICK_PICKS[ id ] );
	}
	S.selModels[ id ] = ( S.selModels[ id ] || 0 ) + 1;
	var err = $( 'modelErr' ); if ( err ) err.classList.remove( 'on' );
	renderSelModels();
}

export function changeModelQty( id, delta ) {
	S.selModels[ id ] = Math.max( 0, ( S.selModels[ id ] || 0 ) + delta );
	if ( S.selModels[ id ] === 0 ) {
		delete S.selModels[ id ];
		delete S.sizeByRow[ id ];
		delete S.otherText[ id ];
	}
	renderSelModels();
}

export function removeModel( id ) {
	delete S.selModels[ id ];
	delete S.sizeByRow[ id ];
	delete S.otherText[ id ];
	renderSelModels();
}

export function getTotalRobots() {
	var n = 0;
	for ( var k in S.selModels ) if ( Object.prototype.hasOwnProperty.call( S.selModels, k ) ) n += S.selModels[ k ];
	return n;
}

function buildSizePicker( rowId ) {
	var fr = S.lang === 'fr';
	var wrap = document.createElement( 'div' );
	wrap.className = 'size-picker-inline';
	var lbl = document.createElement( 'div' );
	lbl.className = 'size-picker-lbl';
	lbl.textContent = fr ? 'Taille du robot :' : 'Robot size:';
	wrap.appendChild( lbl );

	var grid = document.createElement( 'div' );
	grid.className = 'size-picker-grid';
	SIZE_KEYS.forEach( function ( sz, i ) {
		var sel = S.sizeByRow[ rowId ] === sz;
		var card = document.createElement( 'div' );
		card.className = 'size-picker-card' + ( sel ? ' on' : '' );
		card.setAttribute( 'data-ps-size-row', rowId );
		card.setAttribute( 'data-ps-size', sz );

		var img = document.createElement( 'img' );
		img.src = SIZE_IMGS[ sz ];
		img.alt = ( fr ? SIZE_LABELS_FR : SIZE_LABELS_EN )[ i ];
		img.loading = 'lazy';
		img.onerror = function () { this.style.background = 'var(--light)'; this.src = ''; };
		card.appendChild( img );

		var body = document.createElement( 'div' );
		body.className = 'size-picker-body';
		var nm = document.createElement( 'div' );
		nm.className = 'size-picker-name';
		nm.textContent = ( fr ? SIZE_LABELS_FR : SIZE_LABELS_EN )[ i ];
		var dt = document.createElement( 'div' );
		dt.className = 'size-picker-det';
		dt.textContent = ( fr ? SIZE_DETAILS_FR : SIZE_DETAILS_EN )[ i ];
		body.appendChild( nm );
		body.appendChild( dt );
		card.appendChild( body );
		grid.appendChild( card );
	} );
	wrap.appendChild( grid );

	var warn = document.createElement( 'div' );
	warn.id = 'sizeWarn-' + rowId;
	warn.className = 'size-warn';
	warn.textContent = fr ? 'Sélectionnez une taille.' : 'Please select a size.';
	wrap.appendChild( warn );

	return wrap;
}

function buildOtherInput( rowId ) {
	var fr = S.lang === 'fr';
	var wrap = document.createElement( 'div' );
	wrap.className = 'other-input-wrap';
	var inp = document.createElement( 'input' );
	inp.type = 'text';
	inp.value = S.otherText[ rowId ] || '';
	inp.placeholder = fr ? 'Ex: FANUC P-350, robot peinture 7 axes…' : 'Ex: FANUC P-350, painting robot 7 axes…';
	inp.setAttribute( 'data-ps-other-row', rowId );
	wrap.appendChild( inp );
	return wrap;
}

export function renderSelModels() {
	var ids = Object.keys( S.selModels );
	var noM = $( 'noModels' );
	var cont = $( 'selModels' );
	var totWrap = $( 'robotTotal' );
	if ( ! cont ) return;

	if ( noM )     noM.classList.toggle( 'on', ids.length === 0 );
	if ( totWrap ) totWrap.style.display = ids.length > 0 ? 'flex' : 'none';
	cont.innerHTML = '';
	if ( ids.length === 0 ) return;

	var fr = S.lang === 'fr';
	ids.forEach( function ( id ) {
		var m = FANUC_MODELS.find( function ( x ) { return x.id === id; } );
		if ( ! m ) return;
		var qty       = S.selModels[ id ];
		var isUnknown = id === 'unknown' || id === 'noinfonow';
		var isOther   = id === 'other';

		var row = document.createElement( 'div' );
		row.className = 'sel-model-row';
		row.style.cssText = 'flex-direction:column;align-items:stretch;gap:0;width:100%;box-sizing:border-box';

		var top = document.createElement( 'div' );
		top.style.cssText = 'display:flex;align-items:center;gap:10px;justify-content:space-between;width:100%;box-sizing:border-box';

		var info = document.createElement( 'div' );
		info.className = 'smr-info';
		info.style.cssText = 'flex:1;min-width:0;overflow:hidden;word-break:break-word';
		var nm = document.createElement( 'div' ); nm.className = 'smr-name'; nm.textContent = m.name;
		var ct = document.createElement( 'div' ); ct.className = 'smr-cat';
		ct.textContent = m.cat + ( m.axes ? ' · ' + m.axes + ' axes' : '' );
		info.appendChild( nm );
		info.appendChild( ct );

		var qc = document.createElement( 'div' ); qc.className = 'smr-qty';
		var del = document.createElement( 'button' );
		del.type = 'button';
		del.className = 'sqbtn del';
		del.title = fr ? 'Retirer' : 'Remove';
		del.textContent = '✕';
		del.setAttribute( 'data-ps-model-del', id );
		qc.appendChild( del );

		var minus = document.createElement( 'button' );
		minus.type = 'button';
		minus.className = 'sqbtn';
		minus.textContent = '−';
		minus.setAttribute( 'data-ps-model-qty', id );
		minus.setAttribute( 'data-ps-delta', '-1' );
		var val = document.createElement( 'div' ); val.className = 'sqval'; val.textContent = qty;
		var plus = document.createElement( 'button' );
		plus.type = 'button';
		plus.className = 'sqbtn';
		plus.textContent = '+';
		plus.setAttribute( 'data-ps-model-qty', id );
		plus.setAttribute( 'data-ps-delta', '1' );
		qc.appendChild( minus ); qc.appendChild( val ); qc.appendChild( plus );

		top.appendChild( info );
		top.appendChild( qc );
		row.appendChild( top );

		if ( isUnknown ) row.appendChild( buildSizePicker( id ) );
		if ( isOther )   row.appendChild( buildOtherInput( id ) );

		cont.appendChild( row );
	} );

	var pill = $( 'totalPill' );
	if ( pill ) pill.textContent = getTotalRobots();

	// Recalcule la durée dérivée du catalogue à chaque changement de sélection.
	computeDuration();
}

export function selSizeRow( rowId, size ) {
	S.sizeByRow[ rowId ] = size;
	S.robotSize = size;
	var warn = $( 'sizeWarn-' + rowId );
	if ( warn ) warn.classList.remove( 'on' );
	renderSelModels();
}
